import { Injectable } from '@angular/core';
import { ActivatedRouteSnapshot, Router, RouterStateSnapshot, UrlTree } from '@angular/router';
import { Observable } from 'rxjs';
import { LocalStorageService } from '../index.service';

@Injectable({
  providedIn: 'root'
})
export class FeedGuard  {
  constructor(
    private storage:LocalStorageService,
    private router:Router,
  ){}
  canActivate(
    route: ActivatedRouteSnapshot,
    state: RouterStateSnapshot): Observable<boolean | UrlTree> | Promise<boolean | UrlTree> | boolean | UrlTree {
      if(this.storage.getItem('token')){
        return true
      }else{
        this.router.navigate(['/'])
        return false
      }
  }
  
}
